<nav
  class="navbar-default navbar-static-side navbar-fixed sideBar patpatMenu"
  role="navigation"
  (mouseenter)="toggleNavigation(true)"
  (mouseleave)="toggleNavigation(false)"
>
  <div class="iconFix" *ngIf="!(isMobile)">
    <a
      class="pull-left minimalize-styl-2"
      [routerLink]="nav?.routerLink"
      draggable="false"
      [ngClass]="{'pointer-cursor' : (userRole ==='Manager'),'pointerNone' : (userRole!=='User')}"
    >
      <i class="wallicon patpat-icon icon-logo"></i>
    </a>
    <div
      class="img-class"
      [ngClass]="{'pointer-cursor' : (userRole ==='Manager'),'pointerNone' : (userRole!=='User')}"
    >
      <img
        class="site-logo"
        [src]="setLogo()"
        [routerLink]="nav?.routerLink"
        style="height: 20px"
        draggable="false"
      />
    </div>
  </div>
  <div class="sidebar-collapse scroll-back">
    <img
      *ngIf="userInfo"
      class="logoImage"
      draggable="false"
      [src]="coreService.getImageURL(userInfo.belongingCompanyLogo,coreService.getDefaultImage())"
    />
    <ul class="nav metismenu scrollable" id="side-menu" *ngIf="ready">
      <ng-container *ngIf="userRole === 'User' && !(isMobile)">
        <li class="menuTitle hidden-xs">
          <span></span>
          <!-- <hr />  -->
        </li>
        <ng-container>
          <li
            *ngFor="let nav of navBar"
            [ngClass]="{active: nav.activeRoute}"
            class="navbar-expand"
          >
            <ng-container
              *ngIf="nav.refName === 'feed' || nav.refName === 'orgchart' || nav.refName === 'okrsNetworks'"
            >
              <a
                class="nav-item-link"
                *ngIf="nav.subChild.length==0 && nav.routerLink"
                [routerLink]="nav.routerLink"
                [class.activeColor]="isLinkActive(nav)"
                aria-expanded="true"
                (click)="onMenuClick(nav)"
                draggable="false"
              >
                <div class="half-rect"></div>
                <i class="{{nav.iClass}}"></i>
                <span class="nav-label">{{nav?.title |translate}}</span>
                <!-- [ngClass]="{activeColor: nav.activeRoute}" -->
              </a>
              <a
                *ngIf="nav.subChild.length>0 && nav.routerLink"
                [routerLink]="nav.routerLink"
                aria-expanded="false"
                (click)="onMenuClick(nav)"
                draggable="false"
              >
                <i class="{{nav.iClass}}"></i>
                <span class="nav-label">{{nav?.title|translate}}</span>
                <i
                  class="fa float-right"
                  [ngClass]="{'fa-chevron-up': activeChildRoute(nav.refChildName), 'fa-chevron-down': !activeChildRoute(nav.refChildName)}"
                ></i>
              </a>
              <a
                *ngIf="nav.subChild.length>0 && !nav.routerLink"
                aria-expanded="false"
                [ngClass]="{active: activeChildRoute(nav.refChildName)}"
                (click)="onMenuClick(nav)"
                draggable="false"
              >
                <div class="half-rect"></div>
                <i class="{{nav.iClass}}"></i>
                <span class="nav-label">{{nav?.title|translate}}</span>
                <i
                  class="fa float-right m-l-auto"
                  [ngClass]="{'fa-chevron-up': activeChildRoute(nav.refChildName), 'fa-chevron-down': !activeChildRoute(nav.refChildName)}"
                ></i>
              </a>
              <ul
                *ngIf="nav.subChild.length>0"
                class="nav nav-second-level collapse bg-color"
                [ngClass]="{in: activeChildRoute(nav.refChildName)}"
              >
                <li
                  *ngFor="let subNav of nav.subChild"
                  [ngClass]="{active: subNav.activeRoute, 'hidden': isMobile && subNav.hideOnMobile}"
                >
                  <a
                    class="nav-item-link"
                    routerLinkActive="activeColor"
                    [routerLink]="subNav.routerLink"
                    (click)="onMenuClick(subNav)"
                    draggable="false"
                  >
                    <div class="half-rect"></div>
                    <i class="sideIcon"></i>
                    <span class="nav-label">{{subNav?.title|translate}}</span>
                  </a>
                </li>
              </ul>
            </ng-container>
          </li>
          <ng-container class="partition">
            <hr />
            <ng-container>
              <div class="about-me">{{"Employee.AboutMe" | translate}}</div>
              <div class="me-about">{{"Menu.Me" | translate}}</div>
            </ng-container>
          </ng-container>
          <li *ngFor="let nav of navBar" [ngClass]="{active: nav.activeRoute}">
            <ng-container
              *ngIf="!(nav.refName === 'feed' || nav.refName === 'orgchart' || nav.refName === 'okrsNetworks')"
            >
              <a
                class="nav-item-link"
                *ngIf="nav.subChild.length==0 && nav.routerLink"
                [routerLink]="nav.routerLink"
                [class.activeColor]="isLinkActive(nav)"
                aria-expanded="true"
                (click)="onMenuClick(nav)"
                draggable="false"
              >
                <div class="half-rect"></div>
                <i class="{{nav.iClass}}"></i>
                <span class="nav-label">{{nav?.title |translate}}</span>
                <!-- [ngClass]="{activeColor: nav.activeRoute}" -->
              </a>
              <a
                *ngIf="nav.subChild.length>0 && nav.routerLink"
                [routerLink]="nav.routerLink"
                aria-expanded="false"
                (click)="onMenuClick(nav)"
                draggable="false"
              >
                <i class="{{nav.iClass}}"></i>
                <span class="nav-label">{{nav?.title|translate}}</span>
                <i
                  class="fa float-right"
                  [ngClass]="{'fa-chevron-up': activeChildRoute(nav.refChildName), 'fa-chevron-down': !activeChildRoute(nav.refChildName)}"
                ></i>
              </a>
              <a
                *ngIf="nav.subChild.length>0 && !nav.routerLink"
                aria-expanded="false"
                class="nav-item-link"
                draggable="false"
                [ngClass]="{active: activeChildRoute(nav.refChildName) || nav?.isSelected, activeColor: nav.isSelected && !isOpen}"
                (click)="onMenuClick(nav)"
              >
                <div class="half-rect"></div>
                <i class="{{nav.iClass}}"></i>
                <span class="nav-label">{{nav?.title|translate}}</span>
                <i
                  class="fa float-right m-l-auto"
                  [ngClass]="{'fa-chevron-up': activeChildRoute(nav.refChildName), 'fa-chevron-down': !activeChildRoute(nav.refChildName)}"
                ></i>
              </a>
              <ul
                *ngIf="nav.subChild.length>0"
                class="nav nav-second-level collapse bg-color"
                [ngClass]="{in: activeChildRoute(nav.refChildName)}"
              >
                <li
                  *ngFor="let subNav of nav.subChild"
                  [ngClass]="{active: subNav.activeRoute, 'hidden': isMobile && subNav.hideOnMobile}"
                >
                  <a
                    class="nav-item-link"
                    draggable="false"
                    routerLinkActive="activeColor"
                    [routerLink]="subNav.routerLink"
                    (click)="onMenuClick(subNav)"
                  >
                    <div class="half-rect"></div>
                    <i class="sideIcon"></i>
                    <span class="nav-label">{{subNav?.title|translate}}</span>
                  </a>
                </li>
              </ul>
            </ng-container>
          </li>
        </ng-container>
      </ng-container>
      <ng-container *ngIf="userRole === 'User' && isMobile">
        <li class="menuTitle hidden-xs">
          <span></span>
          <!-- <hr />  -->
        </li>
        <ng-container>
          <li *ngFor="let nav of navBar" [ngClass]="{active: nav.activeRoute}">
            <ng-container
              *ngIf="nav.refName === 'feed' || nav.refName === 'orgchart' || nav.refName === 'okrsNetworks'"
            >
              <a
                class="nav-item-link"
                draggable="false"
                *ngIf="nav.subChild.length==0 && nav.routerLink"
                [routerLink]="nav.routerLink"
                [class.activeColor]="isLinkActive(nav)"
                aria-expanded="true"
                (click)="onMenuClick(nav)"
              >
                <div class="half-rect"></div>
                <i class="{{nav.iClass}}"></i>
                <span class="nav-label">{{nav?.title |translate}}</span>
                <!-- [ngClass]="{activeColor: nav.activeRoute}" -->
              </a>
              <a
                *ngIf="nav.subChild.length>0 && nav.routerLink"
                [routerLink]="nav.routerLink"
                aria-expanded="false"
                (click)="onMenuClick(nav)"
                draggable="false"
              >
                <i class="{{nav.iClass}}"></i>
                <span class="nav-label">{{nav?.title|translate}}</span>
                <i
                  class="fa float-right"
                  [ngClass]="{'fa-chevron-up': activeChildRoute(nav.refChildName), 'fa-chevron-down': !activeChildRoute(nav.refChildName)}"
                ></i>
              </a>
              <a
                *ngIf="nav.subChild.length>0 && !nav.routerLink"
                aria-expanded="false"
                [ngClass]="{active: activeChildRoute(nav.refChildName)}"
                (click)="onMenuClick(nav)"
                draggable="false"
              >
                <div class="half-rect"></div>
                <i class="{{nav.iClass}}"></i>
                <span class="nav-label">{{nav?.title|translate}}</span>
                <i
                  class="fa float-right m-l-auto"
                  [ngClass]="{'fa-chevron-up': activeChildRoute(nav.refChildName), 'fa-chevron-down': !activeChildRoute(nav.refChildName)}"
                ></i>
              </a>
              <ul
                *ngIf="nav.subChild.length>0"
                class="nav nav-second-level collapse bg-color"
                [ngClass]="{in: activeChildRoute(nav.refChildName)}"
              >
                <li
                  *ngFor="let subNav of nav.subChild"
                  [ngClass]="{active: subNav.activeRoute, 'hidden': isMobile && subNav.hideOnMobile}"
                >
                  <a
                    class="nav-item-link"
                    draggable="false"
                    routerLinkActive="activeColor"
                    [routerLink]="subNav.routerLink"
                    (click)="onMenuClick(subNav)"
                  >
                    <div class="half-rect"></div>
                    <i class="sideIcon"></i>
                    <span class="nav-label">{{subNav?.title|translate}}</span>
                  </a>
                </li>
              </ul>
            </ng-container>
          </li>
          <ng-container class="partition">
            <hr />
            <ng-container>
              <div class="about-me">{{"Employee.AboutMe" | translate}}</div>
              <div class="me-about">{{"Menu.Me" | translate}}</div>
            </ng-container>
          </ng-container>
          <li *ngFor="let nav of navBar" [ngClass]="{active: nav.activeRoute}">
            <ng-container
              *ngIf="!(nav.refName === 'feed' || nav.refName === 'orgchart' || nav.refName === 'okrsNetworks')"
            >
              <a
                class="nav-item-link"
                draggable="false"
                *ngIf="nav.subChild.length==0 && nav.routerLink"
                [routerLink]="nav.routerLink"
                [class.activeColor]="isLinkActive(nav)"
                aria-expanded="true"
                (click)="onMenuClick(nav)"
              >
                <div class="half-rect"></div>
                <i class="{{nav.iClass}}"></i>
                <span class="nav-label">{{nav?.title |translate}}</span>
                <!-- [ngClass]="{activeColor: nav.activeRoute}" -->
              </a>
              <a
                *ngIf="nav.subChild.length>0 && nav.routerLink"
                [routerLink]="nav.routerLink"
                aria-expanded="false"
                (click)="onMenuClick(nav)"
                draggable="false"
              >
                <i class="{{nav.iClass}}"></i>
                <span class="nav-label">{{nav?.title|translate}}</span>
                <i
                  class="fa float-right"
                  [ngClass]="{'fa-chevron-up': activeChildRoute(nav.refChildName), 'fa-chevron-down': !activeChildRoute(nav.refChildName)}"
                ></i>
              </a>
              <a
                *ngIf="nav.subChild.length>0 && !nav.routerLink"
                aria-expanded="false"
                [ngClass]="{active: activeChildRoute(nav.refChildName)}"
                (click)="onMenuClick(nav)"
                draggable="false"
              >
                <div class="half-rect"></div>
                <i class="{{nav.iClass}}"></i>
                <span class="nav-label">{{nav?.title|translate}}</span>
                <i
                  class="fa float-right m-l-auto"
                  [ngClass]="{'fa-chevron-up': activeChildRoute(nav.refChildName), 'fa-chevron-down': !activeChildRoute(nav.refChildName)}"
                ></i>
              </a>
              <ul
                *ngIf="nav.subChild.length>0"
                class="nav nav-second-level collapse bg-color"
                [ngClass]="{in: activeChildRoute(nav.refChildName)}"
              >
                <li
                  *ngFor="let subNav of nav.subChild"
                  [ngClass]="{active: subNav.activeRoute, 'hidden': isMobile && subNav.hideOnMobile}"
                >
                  <a
                    class="nav-item-link"
                    routerLinkActive="activeColor"
                    [routerLink]="subNav.routerLink"
                    (click)="onMenuClick(subNav)"
                    draggable="false"
                  >
                    <div class="half-rect"></div>
                    <i class="sideIcon"></i>
                    <span class="nav-label">{{subNav?.title|translate}}</span>
                  </a>
                </li>
              </ul>
            </ng-container>
          </li>
        </ng-container>
      </ng-container>

      <ng-container *ngIf="userRole === 'SuperAdmin' && ready">
        <li class="menuTitle hidden-xs">
          <span>{{ 'Generic.System' | translate }}</span>
          <hr />
        </li>
        <ng-container>
          <li
            class="hidden-xs"
            *ngFor="let nav of navBarSuperAdmin"
            [ngClass]="{active: activeRoute(nav?.refName)}"
          >
            <a
              class="nav-item-link"
              *ngIf="nav.routerLink"
              routerLinkActive="activeColor"
              [routerLink]="nav.routerLink"
              (click)="onMenuClick(nav)"
              draggable="false"
            >
              <i class="{{nav.iClass}}"></i>
              <span class="nav-label">{{nav?.title|translate}}</span>
            </a>
            <a
              *ngIf="!nav.routerLink"
              href="#"
              (click)="onMenuClick(nav)"
              draggable="false"
            >
              <i class="{{nav.iClass}}"></i>
              <span class="nav-label">{{nav?.title|translate}}</span>
              <i
                class="fa float-right"
                [ngClass]="{'fa-chevron-down': activeChildRoute(nav.refChildName), 'fa-angle-left': !activeChildRoute(nav.refChildName)}"
              ></i>
            </a>
            <ul
              *ngIf="nav.subChild.length>0"
              class="nav nav-second-level collapse"
              [ngClass]="{in: activeChildRoute(nav.refChildName)}"
            >
              <li
                *ngFor="let subNav of nav.subChild"
                (click)="onMenuClick(subNav)"
                class="nav-item-link"
                [ngClass]="{active: activeChildRoute(nav.refChildName) || nav?.isSelected, activeColor: nav.isSelected && !isOpen}"
              >
                <a [routerLink]="subNav.routerLink" draggable="false">
                  {{subNav?.title|translate}}
                </a>
              </li>
            </ul>
          </li>
        </ng-container>
      </ng-container>

      <ng-container *ngIf="userRole === 'LocalAdmin' && ready">
        <li class="menuTitle hidden-xs">
          <span>{{ 'Company.Division' | translate }}</span>
          <hr />
        </li>
        <ng-container *ngFor="let nav of navBarLocalAdmin">
          <!-- <li
          class="hidden-xs"
          [ngClass]="{active: activeRoute(nav?.refName)}"
        >
          <a
            *ngIf="nav.routerLink"
            [routerLink]="nav.routerLink"
            (click)="onMenuClick(nav)"
            class="nav-item-link"
            [routerLink]="nav.routerLink"
            routerLinkActive="activeColor"
          >
          <div class="half-rect"></div>
            <i class="{{nav.iClass}}"></i>
            <span class="nav-label">{{nav?.title|translate}}</span>
          </a>
          <a *ngIf="!nav.routerLink" href="#" (click)="onMenuClick(nav)" class="nav-item-link"
          [routerLink]="nav.routerLink"
          routerLinkActive="activeColor">
          <div class="half-rect"></div>
            <i class="{{nav.iClass}}"></i>
            <span class="nav-label">{{nav?.title|translate}}</span>
            <i
              class="fa float-right"
              [ngClass]="{'fa-chevron-down': activeChildRoute(nav.refChildName), 'fa-angle-left': !activeChildRoute(nav.refChildName)}"
            ></i>
          </a>
          <ul
            *ngIf="nav.subChild && nav.subChild.length>0"
            class="nav nav-second-level collapse"
            [ngClass]="{in: activeChildRoute(nav.refChildName)}"
          >
            <li
              *ngFor="let subNav of nav.subChild"
              (click)="onMenuClick(subNav)"
              [ngClass]="{active: activeChildRoute(subNav.refName)}"
            >
              <a [routerLink]="subNav.routerLink"  class="nav-item-link"
              [routerLink]="nav.routerLink"
              routerLinkActive="activeColor"
                >{{subNav?.title|translate}}</a
              >
            </li>
          </ul>
        </li> -->
          <li [ngClass]="{active: nav.activeRoute}">
            <ng-container>
              <a
                class="nav-item-link"
                draggable="false"
                *ngIf="nav.subChild.length==0 && nav.routerLink"
                [routerLink]="nav.routerLink"
                [class.activeColor]="isLinkActive(nav)"
                aria-expanded="true"
                (click)="onMenuClick(nav)"
              >
                <div class="half-rect"></div>
                <i class="{{nav.iClass}}"></i>
                <span class="nav-label">{{nav?.title |translate}}</span>
                <!-- [ngClass]="{activeColor: nav.activeRoute}" -->
              </a>
              <a
                *ngIf="nav.subChild.length>0 && nav.routerLink"
                draggable="false"
                [routerLink]="nav.routerLink"
                aria-expanded="false"
                (click)="onMenuClick(nav)"
              >
                <i class="{{nav.iClass}}"></i>
                <span class="nav-label">{{nav?.title|translate}}</span>
                <i
                  class="fa float-right"
                  [ngClass]="{'fa-chevron-up': activeChildRoute(nav.refChildName), 'fa-chevron-down': !activeChildRoute(nav.refChildName)}"
                ></i>
              </a>
              <a
                *ngIf="nav.subChild.length>0 && !nav.routerLink"
                draggable="false"
                aria-expanded="false"
                class="nav-item-link"
                [ngClass]="{active: activeChildRoute(nav.refChildName) || nav?.isSelected, activeColor: nav.isSelected && !isOpen}"
                (click)="onMenuClick(nav)"
              >
                <div class="half-rect"></div>
                <i class="{{nav.iClass}}"></i>
                <span class="nav-label">{{nav?.title|translate}}</span>
                <i
                  class="fa float-right m-l-auto"
                  [ngClass]="{'fa-chevron-up': activeChildRoute(nav.refChildName), 'fa-chevron-down': !activeChildRoute(nav.refChildName)}"
                ></i>
              </a>
              <ul
                *ngIf="nav.subChild.length>0"
                class="nav nav-second-level collapse bg-color"
                [ngClass]="{in: activeChildRoute(nav.refChildName)}"
              >
                <li
                  *ngFor="let subNav of nav.subChild"
                  [ngClass]="{active: subNav.activeRoute, 'hidden': isMobile && subNav.hideOnMobile}"
                >
                  <a
                    class="nav-item-link"
                    draggable="false"
                    routerLinkActive="activeColor"
                    [routerLink]="subNav.routerLink"
                    (click)="onMenuClick(subNav)"
                  >
                    <div class="half-rect"></div>
                    <i class="sideIcon"></i>
                    <span class="nav-label">{{subNav?.title|translate}}</span>
                  </a>
                </li>
              </ul>
            </ng-container>
          </li>
          <!-- <li
            class="hidden-xs"
            *ngFor="let nav of navBarLocalAdmin"
            [ngClass]="{active: activeRoute(nav?.refName)}"
          >
            <a  class="nav-item-link"
              *ngIf="nav.routerLink"
              routerLinkActive="activeColor"
              [routerLink]="nav.routerLink"
              (click)="onMenuClick(nav)"
            >
            <div class="half-rect"></div>
              <i class="{{nav.iClass}}"></i>
              <span class="nav-label">{{nav?.title|translate}}</span>
            </a>
            <a *ngIf="!nav.routerLink" href="#" (click)="onMenuClick(nav)">
              <div class="half-rect"></div>
              <i class="{{nav.iClass}}"></i>
              <span class="nav-label">{{nav?.title|translate}}</span>
              <i
                class="fa float-right"
                [ngClass]="{'fa-chevron-down': activeChildRoute(nav.refChildName), 'fa-angle-left': !activeChildRoute(nav.refChildName)}"
              ></i>
            </a>
            <ul
              *ngIf="nav.subChild && nav.subChild.length>0"
              class="nav nav-second-level collapse"
              [ngClass]="{in: activeChildRoute(nav.refChildName)}"
            >
              <li
                *ngFor="let subNav of nav.subChild"
                (click)="onMenuClick(subNav)"
                [ngClass]="{active: activeChildRoute(subNav.refName)}"
              >
                <a [routerLink]="subNav.routerLink"
                  >{{subNav?.title|translate}}</a
                >
              </li>
            </ul>
          </li> -->
          <ng-container
            class="partition"
            *ngIf="nav.title == 'Menu.Administration'"
          >
            <hr />
            <ng-container>
              <div class="about-me">
                {{ 'Employee.AboutMyDivision' | translate }}
              </div>
              <div class="me-about pd-7">
                <i class="fas fa-user-tag sideIcon" aria-hidden="true"></i>
              </div>
            </ng-container>
          </ng-container>
        </ng-container>
      </ng-container>

      <ng-container *ngIf="userRole === 'CompanyAdmin' && ready">
        <li class="menuTitle hidden-xs">
          <span>{{ 'Generic.Company' | translate }}</span>
          <hr />
        </li>
        <ng-container *ngFor="let nav of navBarCompanyAdmin">
          <li [ngClass]="{active: nav.activeRoute}">
            <ng-container>
              <a
                class="nav-item-link"
                *ngIf="nav.subChild.length==0 && nav.routerLink"
                [routerLink]="nav.routerLink"
                [class.activeColor]="isLinkActive(nav)"
                aria-expanded="true"
                draggable="false"
                (click)="onMenuClick(nav)"
              >
                <div class="half-rect"></div>
                <i class="{{nav.iClass}}"></i>
                <span class="nav-label">{{nav?.title |translate}}</span>
                <!-- [ngClass]="{activeColor: nav.activeRoute}" -->
              </a>
              <a
                *ngIf="nav.subChild.length>0 && nav.routerLink"
                [routerLink]="nav.routerLink"
                aria-expanded="false"
                draggable="false"
                (click)="onMenuClick(nav)"
              >
                <i class="{{nav.iClass}}"></i>
                <span class="nav-label">{{nav?.title|translate}}</span>
                <i
                  class="fa float-right"
                  [ngClass]="{'fa-chevron-up': activeChildRoute(nav.refChildName), 'fa-chevron-down': !activeChildRoute(nav.refChildName)}"
                ></i>
              </a>
              <a
                *ngIf="nav.subChild.length>0 && !nav.routerLink"
                aria-expanded="false"
                draggable="false"
                class="nav-item-link"
                [ngClass]="{active: activeChildRoute(nav.refChildName) || nav?.isSelected, activeColor: nav.isSelected && !isOpen}"
                (click)="onMenuClick(nav)"
              >
                <div class="half-rect"></div>
                <i class="{{nav.iClass}}"></i>
                <span class="nav-label">{{nav?.title|translate}}</span>
                <i
                  class="fa float-right m-l-auto"
                  [ngClass]="{'fa-chevron-up': activeChildRoute(nav.refChildName), 'fa-chevron-down': !activeChildRoute(nav.refChildName)}"
                ></i>
              </a>
              <ul
                *ngIf="nav.subChild.length>0"
                class="nav nav-second-level collapse bg-color"
                [ngClass]="{in: activeChildRoute(nav.refChildName)}"
              >
                <li
                  *ngFor="let subNav of nav.subChild"
                  [ngClass]="{active: subNav.activeRoute, 'hidden': isMobile && subNav.hideOnMobile}"
                >
                  <a
                    class="nav-item-link"
                    routerLinkActive="activeColor"
                    [routerLink]="subNav.routerLink"
                    (click)="onMenuClick(subNav)"
                    draggable="false"
                  >
                    <div class="half-rect"></div>
                    <i class="sideIcon"></i>
                    <span class="nav-label">{{subNav?.title|translate}}</span>
                  </a>
                </li>
              </ul>
            </ng-container>
          </li>

          <!-- <li
          class="hidden-xs"
          *ngFor="let nav of navBarCompanyAdminFirst"
          [ngClass]="{active: activeRoute(nav?.refName)}"
        >
          <a
            *ngIf="nav.routerLink"
            [routerLink]="nav.routerLink"
            (click)="onMenuClick(nav)"
            class="nav-item-link"
            [routerLink]="nav.routerLink"
            routerLinkActive="activeColor"
          >
          <div class="half-rect"></div>
            <i class="{{nav.iClass}}"></i>
            <span class="nav-label">{{nav?.title|translate}}</span>
          </a>
          <a *ngIf="!nav.routerLink" href="#" (click)="onMenuClick(nav)" class="nav-item-link"
          [routerLink]="nav.routerLink"
          routerLinkActive="activeColor">
          <div class="half-rect"></div>
            <i class="{{nav.iClass}}"></i>
            <span class="nav-label">{{nav?.title|translate}}</span>
            <i
              class="fa float-right"
              [ngClass]="{'fa-chevron-down': activeChildRoute(nav.refChildName), 'fa-angle-left': !activeChildRoute(nav.refChildName)}"
            ></i>
          </a>
          <ul
            *ngIf="nav.subChild && nav.subChild.length>0"
            class="nav nav-second-level collapse"
            [ngClass]="{in: activeChildRoute(nav.refChildName)}"
          >
            <li
              *ngFor="let subNav of nav.subChild"
              (click)="onMenuClick(subNav)"
              [ngClass]="{active: activeChildRoute(subNav.refName)}"
            >
              <a [routerLink]="subNav.routerLink"  class="nav-item-link"
              [routerLink]="nav.routerLink"
              routerLinkActive="activeColor"
                >{{subNav?.title|translate}}</a
              >
            </li>
          </ul>
        </li> -->

          <!-- <li
            class="hidden-xs"
            [ngClass]="{active: activeRoute(nav?.refName)}"
          >
            <a
              *ngIf="nav.routerLink"
              [routerLink]="nav.routerLink"
              (click)="onMenuClick(nav)"
              class="nav-item-link"
              [routerLink]="nav.routerLink"
              routerLinkActive="activeColor"
            >
            <div class="half-rect"></div>
              <i class="{{nav.iClass}}"></i>
              <span class="nav-label">{{nav?.title|translate}}</span>
            </a>
            <a *ngIf="!nav.routerLink" href="#" (click)="onMenuClick(nav)" class="nav-item-link"
            [routerLink]="nav.routerLink"
            routerLinkActive="activeColor">
            <div class="half-rect"></div>
              <i class="{{nav.iClass}}"></i>
              <span class="nav-label">{{nav?.title|translate}}</span>
              <i
                class="fa float-right"
                [ngClass]="{'fa-chevron-down': activeChildRoute(nav.refChildName), 'fa-angle-left': !activeChildRoute(nav.refChildName)}"
              ></i>
            </a>
            <ul
              *ngIf="nav.subChild && nav.subChild.length>0"
              class="nav nav-second-level collapse"
              [ngClass]="{in: activeChildRoute(nav.refChildName)}"
            >
              <li
                *ngFor="let subNav of nav.subChild"
                (click)="onMenuClick(subNav)"
                [ngClass]="{active: activeChildRoute(subNav.refName)}"
              >
                <a [routerLink]="subNav.routerLink"  class="nav-item-link"
                [routerLink]="nav.routerLink"
                routerLinkActive="activeColor"
                  >{{subNav?.title|translate}}</a
                >
              </li>
            </ul>
          </li> -->
          <ng-container
            class="partition"
            *ngIf="nav.title == 'Menu.Administration'"
          >
            <hr />
            <ng-container>
              <div class="about-me">
                {{ 'Employee.AboutMyCompany' | translate }}
              </div>
              <div class="me-about pd-7">
                <i class="fas fa-user-cog sideIcon" aria-hidden="true"></i>
              </div>
            </ng-container>
          </ng-container>
        </ng-container>
      </ng-container>

      <ng-container *ngIf="userRole === 'Manager' && ready">
        <li class="menuTitle hidden-xs">
          <span>{{ 'Generic.Team' | translate }}</span>
          <hr />
        </li>
        <ng-container *ngFor="let nav of navBarManager">
          <li [ngClass]="{active: nav.activeRoute}">
            <ng-container>
              <a
                class="nav-item-link 11"
                *ngIf="nav.subChild.length==0 && nav.routerLink"
                [routerLink]="nav.routerLink"
                [class.activeColor]="isLinkActive(nav)"
                aria-expanded="true"
                draggable="false"
                (click)="onMenuClick(nav)"
              >
                <div class="half-rect 11"></div>
                <i class="{{nav.iClass}}"></i>
                <span class="nav-label">{{nav?.title |translate}}</span>
                <!-- [ngClass]="{activeColor: nav.activeRoute}" -->
              </a>
              <a
                *ngIf="nav.subChild.length>0 && nav.routerLink"
                [routerLink]="nav.routerLink"
                aria-expanded="false"
                (click)="onMenuClick(nav)"
              >
                <i class="{{nav.iClass}}"></i>
                <span class="nav-label">{{nav?.title|translate}}</span>
                <i
                  class="fa float-right"
                  [ngClass]="{'fa-chevron-up': activeChildRoute(nav.refChildName), 'fa-chevron-down': !activeChildRoute(nav.refChildName)}"
                ></i>
              </a>
              <a
                *ngIf="nav.subChild.length>0 && !nav.routerLink"
                aria-expanded="false"
                draggable="false"
                class="nav-item-link 22"
                [ngClass]="{active: activeChildRoute(nav.refChildName) || nav?.isSelected, activeColor: nav.isSelected && !isOpen}"
                (click)="onMenuClick(nav)"
              >
                <div class="half-rect 22"></div>
                <i class="{{nav.iClass}}"></i>
                <span class="nav-label">{{nav?.title|translate}}</span>
                <i
                  class="fa float-right m-l-auto"
                  [ngClass]="{'fa-chevron-up': activeChildRoute(nav.refChildName), 'fa-chevron-down': !activeChildRoute(nav.refChildName)}"
                ></i>
              </a>
              <ul
                *ngIf="nav.subChild.length>0"
                class="nav nav-second-level collapse bg-color"
                [ngClass]="{in: activeChildRoute(nav.refChildName)}"
              >
                <li
                  *ngFor="let subNav of nav.subChild"
                  [ngClass]="{active: subNav.activeRoute, 'hidden': isMobile && subNav.hideOnMobile}"
                >
                  <a
                    class="nav-item-link 33"
                    routerLinkActive="activeColor"
                    [routerLink]="subNav.routerLink"
                    (click)="onMenuClick(subNav)"
                    draggable="false"
                  >
                    <div class="half-rect 33"></div>
                    <i class="sideIcon"></i>
                    <span class="nav-label">{{subNav?.title|translate}}</span>
                  </a>
                </li>
              </ul>
            </ng-container>
          </li>
          <!-- <li
            class="hidden-xs"
            *ngFor="let nav of navBarManager"
            [ngClass]="{active: activeRoute(nav?.refName)}"
          >
            <a
              *ngIf="nav.routerLink"
              [routerLink]="nav.routerLink"
              (click)="onMenuClick(nav)"
              class="nav-item-link"
              [routerLink]="nav.routerLink"
              routerLinkActive="activeColor"
            >
            <div class="half-rect"></div>
              <i class="{{nav.iClass}}"></i>
              <span class="nav-label">{{nav?.title|translate}}</span>
            </a>
            <a *ngIf="!nav.routerLink" href="#" (click)="onMenuClick(nav)"  class="nav-item-link"
            [routerLink]="nav.routerLink"
            routerLinkActive="activeColor">
            <div class="half-rect"></div>
              <i class="{{nav.iClass}}"></i>
              <span class="nav-label">{{nav?.title|translate}}</span>
              <i
                class="fa float-right"
                [ngClass]="{'fa-chevron-down': activeChildRoute(nav.refChildName), 'fa-angle-left': !activeChildRoute(nav.refChildName)}"
              ></i>
            </a>
            <ul
              *ngIf="nav.subChild?.length>0"
              class="nav nav-second-level collapse"
              [ngClass]="{in: activeChildRoute(nav.refChildName)}"
            >
              <li
                *ngFor="let subNav of nav.subChild"
                (click)="onMenuClick(subNav)"
                [ngClass]="{active: activeChildRoute(subNav.refName)}"
              >
                <a [routerLink]="subNav.routerLink"
                  >{{subNav?.title|translate}}</a
                >
              </li>
            </ul>
          </li> -->
        </ng-container>
      </ng-container>

      <!-- <li (click)="onLogout()" style="padding-top: 10px">
        <a href="javascript:void(0)"
          ><i class="fa fa-sign-out sideIcon"></i>
          <span class="nav-label">{{ 'Menu.Logout' | translate }}</span></a
        >
      </li> -->

      <!-- <li>
        <a
          *ngIf="userInfo"
          href="{{(userInfo.language === 'it') ? 'https://patpat360.com/it/help-center/' : 'https://patpat360.com/help-center/'}}"
          target="_blank"
        >
        <div class="half-rect"></div>
          <i class="fa fa-info sideIcon help-icon"></i>
          <span class="nav-label">{{ 'Menu.HelpCenter' | translate }}</span></a
        >
      </li> -->
      <!-- <li>
        <span
          class="nav-label menu-fontcolor menuNoteSmall"
          (click)="onVersionClick()"
        >
          PatPat360 Ver. {{version}}</span
        >
      </li> -->
      <div
        *ngIf="isOpen || isMobile"
        [ngClass]="{'zero-bottom' : isMobile}"
        class="version"
      >
        {{version}}
      </div>
    </ul>
  </div>
</nav>
